export const EmployeeReviewActionTypes = {
  FETCH_ALL_EMPLOYEE_REVIEW: "FETCH_ALL_EMPLOYEE_REVIEW",
  FETCH_ALL_EMPLOYEE_REVIEW_RESET: "FETCH_ALL_EMPLOYEE_REVIEW_RESET",
  FETCH_ALL_EMPLOYEE_REVIEW_FAILURE: "FETCH_ALL_EMPLOYEE_REVIEW_FAILURE",
  FETCH_ALL_EMPLOYEE_REVIEW_SUCCESS: "FETCH_ALL_EMPLOYEE_REVIEW_SUCCESS",
};
